import { jsx as _jsx } from "react/jsx-runtime";
import Div from '../Page/Div';
import { Link } from 'react-router-dom';
import FixedContainer from '../Page/FixedContainer';
import AccordionButtonGraphics from '../UI/AccordionButtonGraphics';
const HomePricingSection = ({ content, idx, allowOpen, }) => {
    const { title, details, buttons } = content?.home_page_pricing ?? {};
    return (_jsx(FixedContainer, { idx: idx, allowOpen: allowOpen, parentClassName: `home-pricing-container`, sliderClassName: `home-pricing-wrapper`, children: [
            _jsx(Div, { blocked: !allowOpen, className: "home-pricing-title", delay: 0, noScale: true, children: _jsx("div", { className: "home-pricing-title-wrapper", children: title }) }, "0"),
            _jsx(Div, { blocked: !allowOpen, className: "home-pricing-details", delay: 1, noScale: true, children: details }, "1"),
            ...(buttons ?? []).map((item, idx) => {
                const { title, url } = item.button;
                return (_jsx(Div, { blocked: !allowOpen, className: `home-pricing-button${!idx ? ' first-button' : ''}`, delay: idx + 1, noScale: true, children: _jsx(Link, { to: url, "aria-label": title, children: _jsx(AccordionButtonGraphics, { children: title }) }) }, "2"));
            }),
        ] }));
};
export default HomePricingSection;
